module.exports = __webpack_public_path__ + "img/black-new.29d88e00.png";